module.exports = __webpack_public_path__ + "img/Menu-10.7a7a7289.png";